import React, { useState } from "react";

import LeftTestConsole from "./LeftTestConsole";
import MiddleTestConsole from "./MiddleTestConsole";
import MobileQuestionPalette from "./MobileQuestionPalette";
import "../styles/mobileconsole.css";

const MobileConsole = ({
  quesData,
  catName,
  type,
  testId,

  MyTimer,
  time,
  timeExpired,
  rankArray,

  curQues,
  ansArray,
  visitedArr,

  setAnswer,
  nextQues,
  preQues,
  clearResponse,
  setQues,
   onSubmitClick,
   
}) => {

 // const [showPalette, setShowPalette] = useState(false);

  

  return (

    <div className="mobile-console">

      {/* Header */}

      <div className="mc-header">

        <h2 className="mc-title">
          {catName.toUpperCase()}
        </h2>

        <div className="mc-subtitle">
          Full Practice Test
        </div>

        <div className="mc-status">

          <div className="mc-status-box">
            <span className="mc-label">
              Question
            </span>

            <span className="mc-value">
              {curQues + 1} / {quesData.length}
            </span>
          </div>

          <div className="mc-status-box">
            <span className="mc-label">
              Time Left
            </span>

            <span className="mc-value">
              <MyTimer expiryTimestamp={time} />
            </span>
          </div>

        </div>

      </div>

      {/* Question */}

     <div className="mc-question-wrapper">

    <div className="mc-question-scroll">

        <MiddleTestConsole
            questions={quesData}
            curQues={curQues}
            nextQues={nextQues}
            preQues={preQues}
            clearResponse={clearResponse}
            setAnswer={setAnswer}
            ansArray={ansArray}
            mobile={true}
        />

    </div>

</div>

<div className="mobile-bottom-space"></div>

{/* Navigation */}
<div className="mobile-nav">

    <button
        className="mobile-nav-btn ghost"
        onClick={preQues}
        disabled={curQues===0}
    >
        ← Previous
    </button>

    <button
        className="mobile-nav-btn warn"
        onClick={clearResponse}
    >
        Clear
    </button>

    <button
        className="mobile-nav-btn primary"
        onClick={nextQues}
        disabled={curQues===quesData.length-1}
    >
        Next →
    </button>

</div>


      {/* Palette */}

<div className="mc-palette">

    <MobileQuestionPalette
        quesData={quesData}
        ansArray={ansArray}
        visitedArr={visitedArr}
        curQues={curQues}
        setQues={setQues}
        onSubmitClick={onSubmitClick}
    />

</div>







    </div>




  );

};

export default MobileConsole;